import React, { useEffect, useState } from 'react';
import { StyleSheet, SafeAreaView, Image, Dimensions, Platform, useWindowDimensions, } from 'react-native';
import { useTheme, } from '@react-navigation/native';
import Selector from '../../components/LanguageSelector/LanguageSelector';
import { Card } from 'react-native-paper';
import { useSettings } from '../../hooks/useSettings';
import SettingsEmployeeScreen from './SettingsEmployeeScreen';
import { useTranslation } from 'react-i18next';
import useRole from '../../hooks/userRole';
import { useSafeAreaInsets } from "react-native-safe-area-context";

var width = Dimensions.get('window').width;

const SettingsScreen = () => {
    const { colors } = useTheme()
    const insets = useSafeAreaInsets();
    const { isAdmin } = useRole();
    const styles = makeStyles(colors, insets)
    const { t } = useTranslation();
    const { getSettings, getEmployeeTabs, getTrainingTabs } = useSettings();
    //#endregion

    // * Get Different Settings based on the logged in UserRights 
    useEffect(() => {
        {
            isAdmin &&
                getSettings().catch(console.error)
        }
        getEmployeeTabs().catch(console.error)
        getTrainingTabs().catch(console.error)
    }, [])

    return (
        <SafeAreaView style={styles.mainView}>
            <Card style={styles.cardstyle} >
                <Card.Content>
                    <Selector />
                </Card.Content >
            </Card >
            {isAdmin && Platform.OS === 'web' && <Card style={styles.cardstyle} >
                <Card.Content>
                    <SettingsEmployeeScreen />
                </Card.Content >
            </Card >
            }
        </SafeAreaView>
    )
}

const makeStyles = (colors, insets) => StyleSheet.create({
    mainView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: Math.max(insets.bottom + 24, 40),
    },
    subView: {
        alignItems: 'center',
    },
    cardstyle: {
        width: (Platform.OS === 'web' && width > 1200) ? width / 2 : '95%',
        margin: 10,
        borderRadius: 35,
        elevation: 3,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
    },
});

export default SettingsScreen;